import * as types from './actionTypes';

export const getUserList = (payload) => {
  return {
    type: types.GET_USER_LIST,
    payload,
  };
};
export const getUserExportList = (payload) => {
  return {
    type: types.GET_USER_EXPORT_LIST,
    payload,
  };
};

export const getNextPageUserList = (payload) => {
  return {
    type: types.GET_NEXT_PAGE_USER_LIST,
    payload,
  };
};

export const setUserList = (payload) => {
  return {
    type: types.SET_USER_LIST,
    payload,
  };
};
export const setUserExportList = (payload) => {
  return {
    type: types.SET_USER_EXPORT_LIST,
    payload,
  };
};

export const getRole = () => {
  return {
    type: types.GET_ROLE,
  };
};

export const setRole = (payload) => {
  return {
    type: types.SET_ROLE,
    payload,
  };
};

export const inActiveUser = (payload) => {
  return {
    type: types.INACTIVE_USER,
    payload,
  };
};
export const inActiveUserSuccess = (payload) => {
  return {
    type: types.INACTIVE_USER_SUCCESS,
    payload,
  };
};
export const updateURLs = (payload) => {
  return {
    type: types.UPDATE_URLS,
    payload,
  };
};
export const updateURLSuccess = (payload) => {
  return {
    type: types.UPDATE_URL_SUCCESS,
    payload,
  };
};
export const updateURLError = (payload) => {
  return {
    type: types.UPDATE_URL_ERROR,
    payload,
  };
};
export const switchRole = (payload) => {
  return {
    type: types.SWITCH_ROLE,
    payload,
  };
};

export const switchRoleSuccess = (payload) => {
  return {
    type: types.SWITCH_ROLE_SUCCESS,
    payload,
  };
};

export const updateUser = (payload) => ({
  type: types.UPDATE_USER,
  payload,
});

export const updateUserSuccess = (payload) => ({
  type: types.UPDATE_USER_SUCCESS,
  payload,
});

export const updateUserError = (payload) => ({
  type: types.UPDATE_USER_ERROR,
  payload,
});

export const getUserDetails = (payload) => ({
  type: types.GET_USER_DETAILS,
  payload,
});

export const setUserDetails = (payload) => ({
  type: types.SET_USER_DETAILS,
  payload,
});

export const clearUserDetails = () => ({
  type: types.CLEAR_USER_DETAILS,
});
